import {
  EDIT_FIRST_NAME, EDIT_LAST_NAME, EDIT_SURNAME, EDIT_EMAIL,
  EDIT_PHONE, CLEAR_PROFILE_FORM, SWITCH_PERM_NEWS,
  SWITCH_PERM_MEDIUM_STATUS
} from "../actions/profile_form_actions";

const initialState = {
  first_name_profile: '',
  last_name_profile: '',
  surname_profile: '',
  email_profile: '',
  phone_profile: '',
  perm_news_profile: false,
  perm_system_messages_profile: false
}

export const profileFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_FIRST_NAME: {
      return {
        ...state,
        first_name_profile: action.first_name_profile
      }
    }
    case EDIT_LAST_NAME: {
      return {
        ...state,
        last_name_profile: action.last_name_profile
      }
    }
    case EDIT_SURNAME: {
      return {
        ...state,
        surname_profile: action.surname_profile
      }
    }
    case EDIT_EMAIL: {
      return {
        ...state,
        email_profile: action.email_profile
      }
    }
    case EDIT_PHONE: {
      return {
        ...state,
        phone_profile: action.phone_profile
      }
    }
    case SWITCH_PERM_NEWS: {
      return {
        ...state,
        perm_news_profile: action.perm_news_profile
      }
    }
    case SWITCH_PERM_MEDIUM_STATUS: {
      return {
        ...state,
        perm_system_messages_profile: action.perm_system_messages_profile
      }
    }
    case CLEAR_PROFILE_FORM: {
      return {
        ...state,
        first_name_profile: '',
        last_name_profile: '',
        surname_profile: '',
        email_profile: '',
        phone_profile: '',
        perm_news_profile: false,
        perm_system_messages_profile: false
      }
    }
    default: return state;
  }
}
